import Entity from './entity';

export default class OrderMan extends Entity<number> {
    // tslint:disable-next-line:member-access
    orderman: string;
    // tslint:disable-next-line:member-access
    ordertel: string;
    // tslint:disable-next-line:member-access
    addressall: string;
    // tslint:disable-next-line:member-access
    dealtype: string;
    // tslint:disable-next-line:member-access
    branch: string;
    // tslint:disable-next-line:member-access
    usermemo: string;
    longitude:string;
    latitude:string;
    constructor() {
        super();
        this.orderman   = '';
        this.ordertel   = '';
        this.addressall = '';
        this.id         = 0;
        this.dealtype   = '';
        this.branch     = '';
        this.usermemo   = '';
        this.longitude        = '';
        this.latitude        ='';
    }
}
